import {CustomerModel} from './customer.model';
import {SiteModel} from './site.model';
import {ContactModel} from './contact.model';
import {DetaillineDTOModel} from './detaillineDTO.model';
import {ProjectDTOModel} from './projectDTO.model';
import {PrintingOptionsModel} from './printing-options.model';
import {PatientDTOModel} from './patientDTO.model';
import {OperatorModel} from './operator.model';
import {PhotoDTOModel} from './photoDTO.model';
import {ServiceJobDTOModel} from './service-job-DTO.model';
import {TimeClockingDTOModel} from './time-clocking-DTO.model';
import {SimpleEngineerBeanModel} from './simple-engineer-bean.model';
import {DepositBeanModel} from './deposit-bean.model';
import {CheckBoxOptionsBeanModel} from './checkbox-options-bean.model';

export class DocumentModel {
    public calendar: string;
    public checkBoxOptionsBean: CheckBoxOptionsBeanModel;
    public clockingState: number;
    public cloneOfDetailLines: DetaillineDTOModel[];
    public comment: string;
    public contact: ContactModel;
    public createDocument: boolean;
    public creationDate: string;
    public customer: CustomerModel;
    public customerOrderNo: string;
    public customerRef: number;
    public deposit: DepositBeanModel;
    public detailLines: DetaillineDTOModel[];
    public deviceId: string;
    public discHire: number;
    public discount: string;
    public discSale: number;
    public documentId: number;
    public documentNumber: number;
    public documentType: number;
    public driverId: number;
    public engineerSignature: string;
    public equipment: DetaillineDTOModel[];
    public existingOrderLines: any;
    public jemserStandalone: number;
    public lat: number;
    public lng: number;
    public location: number;
    public operator: OperatorModel;
    public orderNumber: string;
    public originalDocumentType: number;
    public packageSeq: number;
    public parentDocument: DocumentModel;
    public patient: PatientDTOModel;
    public patientId: string;
    public photosBase64: PhotoDTOModel[];
    public photosURL: PhotoDTOModel[];
    public policy: string;
    public priceList: string;
    public printerCopies: number;
    public printingOptionsBean: PrintingOptionsModel;
    public productTypes: DetaillineDTOModel[];
    public project: ProjectDTOModel;
    public queuedToOperatorId: number;
    public queueId: number;
    public queueStatus: number;
    public requestId: number;
    public reverseOffhireDetailLines: DetaillineDTOModel[];
    public savedOnDevice: Date;
    public scheduledDate: string;
    public selectedEngineer: SimpleEngineerBeanModel;
    public selectedInvoicePrinter: string;
    public selectedOperator: string;
    public selectedPlant: DetaillineDTOModel;
    public selectedPrinter: string;
    public selectedReceiptPrinter: string;
    public selectedSalesPerson: number;
    public selectedWindowTillDrawer: string;
    public serviceEnquiryWorklistId: number;
    public serviceJob: ServiceJobDTOModel;
    public signature: string;
    public signatureContact: ContactModel;
    public site: SiteModel;
    public tender: string;
    public timeClockingDTO: TimeClockingDTOModel[];
    public sigcapQueueId: number;
    public replacementItem: DetaillineDTOModel;

    [x: string]: any;
}
